/**
 * Gets domain from email address
 * @param email
 * @returns string
 */
export const GetDomainFromEmail = (email: string): string => {
    return email.substring(email.lastIndexOf("@") + 1);
};
